import { echartsDarkTheme } from "../constants/echartsDarkTheme.js";
import dayjs from "dayjs";
import React, { useEffect } from "react";
import { Constants, useAtalayaContext } from "@therms/atalaya";
import { jsx } from "react/jsx-runtime";
import * as echarts from "echarts/core";
import { GridComponent } from "echarts/components";
import { BarChart } from "echarts/charts";
import { CanvasRenderer } from "echarts/renderers";
//#region src/modules/Stats/shared/HourOfDayBarChart.tsx
echarts.use([
	GridComponent,
	BarChart,
	CanvasRenderer
]);
echarts.registerTheme("THERMS Dark", echartsDarkTheme);
function HourOfDayBarChart({ hourCount }) {
	const { isDarkMode } = useAtalayaContext();
	const containerRef = React.useRef(null);
	useEffect(() => {
		if (!containerRef.current || !hourCount) return void 0;
		const chart = echarts.init(containerRef.current, isDarkMode ? "THERMS Dark" : "light");
		const dowList = [
			0,
			1,
			2,
			3,
			4,
			5,
			6,
			7,
			8,
			9,
			10,
			11,
			12,
			13,
			14,
			15,
			16,
			17,
			18,
			19,
			20,
			21,
			22,
			23
		].map((hour) => hourCount[hour] ?? 0);
		let highHRIndex;
		let lowHRIndex;
		Object.entries(dowList).forEach(([index, count]) => {
			if (count === Math.max(...dowList)) highHRIndex = Number(index);
			if (count === Math.min(...dowList)) lowHRIndex = Number(index);
		});
		const option = {
			series: [{
				data: dowList.map((count, i) => ({
					itemStyle: { color: i === highHRIndex ? Constants.Color[isDarkMode ? "Dark" : "Light"].InfoLight : i === lowHRIndex ? Constants.Color[isDarkMode ? "Dark" : "Light"].InfoDark : Constants.Color[isDarkMode ? "Dark" : "Light"].Info },
					value: count
				})),
				type: "bar"
			}],
			title: {
				left: "center",
				text: "Activity Per Time of Day"
			},
			xAxis: {
				data: new Array(24).fill(0).map((_, i) => dayjs().set("hour", i).format("ha")),
				type: "category"
			},
			yAxis: { type: "value" }
		};
		chart.setOption(option);
		return () => chart.dispose();
	}, [
		hourCount,
		containerRef.current,
		isDarkMode
	]);
	return /* @__PURE__ */ jsx("div", {
		className: "h-full w-full",
		ref: containerRef,
		style: {
			height: 300,
			width: "100%"
		}
	});
}
//#endregion
export { HourOfDayBarChart };

//# sourceMappingURL=HourOfDayBarChart.js.map